module.exports = __webpack_public_path__ + "img/ring_r_o_null_null@2x.7fef450e.png";